/**
 * Port of Java's `String.hashCode`.
 * @see https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param obj
 * @returns {number} hash code of JSON string representation of given object
 */
export const hashCode = (obj: any): number => {
    let hash = 0
    if (obj === undefined) {
        return hash
    }
    const s = JSON.stringify(obj)
    for (let i = 0; i < s.length; i++) {
        const char = s.charCodeAt(i)
        // exceptions for speed; hashing methodology needn't be understandable
        /* tslint:disable:no-bitwise no-magic-numbers */
        hash = ((hash << 5) - hash) + char
        hash = hash & hash
        /* tslint:disable:no-bitwise no-magic-numbers */
    }
    return hash
}

/**
 * Get the sha256 hash of a string, in hex format
 * @param input - string
 * @returns {string} sha256 hash code of input string, in hex format
 */
export const sha256 = async (input: string): Promise<string> => {
    /* istanbul ignore next */
    // window.crypto.subtle is available only in secure contexts (HTTPS)
    if (window.crypto && window.crypto.subtle) {
        const inputUint8 = new TextEncoder().encode(input)
        return window.crypto.subtle.digest('SHA-256', inputUint8)
            .then((hashBuffer) => {
                return arrayBufferToHex(hashBuffer)
            })
    } else {
        return Promise.reject(new Error('crypto not available'))
    }
}

/**
 * @param input - array buffer
 * @returns {string} hex representation of array buffer
 */
export const arrayBufferToHex = (input: ArrayBuffer): string => {
    const hashArray = Array.from(new Uint8Array(input))
    const hexBase = 16
    const hexInByte = 2
    return hashArray.map((b) => b.toString(hexBase).padStart(hexInByte, '0')).join('')
}
